<template>
  <div class="all">
    <div class="areas-header">
      <b>{{ $t("areas") }}</b>
    </div>
    <div class="graph-1">
      <apexcharts
        v-if="currentDisplay == 1"
        ref="demoChart"
        :options="graphOne"
        width="95%"
        height="300px"
        :series="graphOne.series"
      >
      </apexcharts>
      <apexcharts
        v-if="currentDisplay == 2"
        ref="demoChart"
        :options="graphOne"
        width="95%"
        height="160px"
        :series="graphOne.series"
      >
      </apexcharts>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Mediator from "../utilites/Mediator";
import { defaultSuccess } from "@/global";

var instanceVue = {};

export default {
  components: { apexcharts: VueApexCharts },

  data: function () {
    return {
      currentDisplay: 2,
      graphOne: {
        series: [],
        chart: {
          id: "graph1",
          toolbar: {
            show: false,
          },
          type: "line",
          events: {
            dataPointSelection: function (event, chartContext, config) {
              Mediator.notify(
                instanceVue.graphOne.labels[
                  config.w.globals.labels[config.dataPointIndex] - 1
                ],
                "update-graph-2-name"
              );
            },
          },
        },

        stroke: {
          width: [0, 3],
        },

        states: { active: { filter: { type: "none" } } },

        dataLabels: {
          enabled: true,
          formatter: (val, { seriesIndex }) =>
            seriesIndex === 1                 // 1 = linha preta
              ? Number(val).toFixed(0)        // 2 casas
              : Number(val).toFixed(2),       // ou .toFixed(2) se também quiser nas barras
          style: { colors: ["#FFFFFF00", "#000"] }
        },

        legend: {
          show: true,
          customLegendItems: [
            this.$t("aderente"),
            this.$t("nao-aderente"),
            this.$t("ocor-tratadas"),
          ],
          markers: {
            fillColors: ["#00A39F", "#FF7100", "#000"],
          },
        },

        labels: [],

        xaxis: {
          labels: {
            style: {
              fontSize: "13px",
              fontWeight: 700,
            },
          },
        },

        plotOptions: {
          bar: {
            borderRadius: 4,
          },
        },

        colors: [
          function ({ dataPointIndex }) {
            const val = instanceVue.adherenceHeadersResults[dataPointIndex];
            const thr = instanceVue.adherenceMinimunHeadersValues[dataPointIndex];
            return val < thr ? "#FF7100" : "#00A39F";
          },
          "#000000",
        ],

        tooltip: {
          enabled: true,
          y: {
            formatter: (val, { seriesIndex }) =>
              seriesIndex === 1
                ? Number(val).toFixed(0)   // linha preta
                : Number(val).toFixed(2)   // barras
          }
        },

        yaxis: {
          labels: {
            formatter: (val) => Number(val).toFixed(0)
          }
        },
      },
      adherenceHeadersResults: [],
      adherenceHeaders: [],
      adherenceMinimunHeadersValues: [],
      percentOcurrenceHeaders: [],
      percentOcurrenceHeadersResults: [],
    };
  },
  methods: {
    loadChart(data) {
      this.loadDisplayHeight();
      let adherenceHeaders = [];
      instanceVue.adherenceHeadersResults = [];
      instanceVue.adherenceHeaders = [];
      instanceVue.adherenceMinimunHeadersValues = [];
      instanceVue.percentOcurrenceHeaders = [];
      instanceVue.percentOcurrenceHeadersResults = [];

      for (var header in data.adherenceHeadersResults) {
        adherenceHeaders.push([header, data.adherenceHeadersResults[header]]);
      }

      adherenceHeaders.sort(function (a, b) {
        return a[1] - b[1];
      });

      adherenceHeaders.forEach((element) => {
        instanceVue.adherenceHeaders.push(element[0]);
        instanceVue.adherenceHeadersResults.push(element[1]);
        instanceVue.adherenceMinimunHeadersValues.push(
          Math.trunc(data.adherenceMinimunHeaders[element[0]])
        );
        instanceVue.percentOcurrenceHeadersResults.push(
          Number(data.percentOcurrenceHeadersResults[element[0]])
        );
      });

      instanceVue.graphOne.series = [
        {
          name: this.$t("aderencias"),
          type: "column",
          data: instanceVue.adherenceHeadersResults,
        },
        {
          name: this.$t("ocor-tratadas-0"),
          type: "line",
          data: instanceVue.percentOcurrenceHeadersResults,
        },
      ];
      instanceVue.graphOne.labels = instanceVue.adherenceHeaders;
      this.$refs.demoChart.updateOptions({
        labels: instanceVue.adherenceHeaders,
      });
    },

    loadDisplayHeight() {
      if (window.innerHeight < 799) {
        this.currentDisplay = 2;
      } else this.currentDisplay = 1;
    },

    showMessage(area) {
      defaultSuccess(`${area} ` + this.$t("carregada-0"));
    },
  },

  mounted() {
    instanceVue = this;
    Mediator.notify(instanceVue, "init-graph-1");
  },
};
</script>

<style scoped>
.all {
  display: grid;
  grid-template-columns: 1fr 6fr;
  align-items: center;
}

.areas-header {
  margin-left: 50px;
  margin-top: 0px;
  font-size: 15px;
  font-weight: 400;
}

.graph-1 {
  margin-right: 220px;
  cursor: pointer;
}

@media only screen and (max-height: 798px) {
  .all {
    grid-template-columns: 1.1fr 6fr;
  }

  .graph-1 {
    margin-right: 165px;
  }

  .areas-header {
    margin-left: 20px;
    font-size: 13px;
  }
}

:deep(.apexcharts-legend-series),
:deep(.apexcharts-legend-marker),
:deep(.apexcharts-legend-text) {
  cursor: default !important;
}
</style>